const DIGITS = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín']
const SCALES = ['', 'nghìn', 'triệu', 'tỷ']

// Đọc nhóm 3 chữ số. full = true khi đã có nhóm lớn hơn đứng trước -> đọc đủ "không trăm", "linh".
const _readTriple = (number, full) => {
    const hundreds = Math.floor(number / 100)
    const tens = Math.floor((number % 100) / 10)
    const units = number % 10
    const words = []

    if (hundreds > 0 || full) {
        words.push(DIGITS[hundreds], 'trăm')
    }

    if (tens > 1) {
        words.push(DIGITS[tens], 'mươi')
    } else if (tens === 1) {
        words.push('mười')
    } else if (units > 0 && (hundreds > 0 || full)) {
        words.push('linh')
    }

    if (units === 1 && tens > 1) {
        words.push('mốt')
    } else if (units === 5 && tens > 0) {
        words.push('lăm')
    } else if (units > 0) {
        words.push(DIGITS[units])
    }

    return words.join(' ')
}

/**
 * Đọc số nguyên không âm thành chữ tiếng Việt, VD 1505 -> "Một nghìn năm trăm linh năm".
 * Dùng cho dòng "Tổng số lượng (viết bằng chữ)" trên phiếu xuất kho.
 *
 * @param {number|string} value
 * @return {string} chuỗi rỗng khi không phải số nguyên không âm
 */
const numberToVietnameseWords = (value) => {
    const number = Number(value)
    if (value === null || value === '' || !Number.isSafeInteger(number) || number < 0) return ''
    if (number === 0) return 'Không'

    // Tách nhóm 3 chữ số từ phải sang; quá "tỷ" thì lặp lại "tỷ" (nghìn tỷ, triệu tỷ...).
    const groups = []
    let rest = number
    while (rest > 0) {
        groups.push(rest % 1000)
        rest = Math.floor(rest / 1000)
    }

    const words = []
    for (let i = groups.length - 1; i >= 0; i--) {
        const group = groups[i]
        if (group > 0) {
            words.push(_readTriple(group, words.length > 0))
            if (i % 3 > 0) words.push(SCALES[i % 3])
        }

        // Nhóm tỷ (i = 3, 6...) luôn ghi "tỷ" khi phía trước đã có chữ, kể cả nhóm này bằng 0.
        if (i > 0 && i % 3 === 0 && words.length > 0) {
            words.push(SCALES[3])
        }
    }

    const text = words.join(' ').replace(/\s+/g, ' ').trim()

    return text.charAt(0).toUpperCase() + text.slice(1)
}

export default numberToVietnameseWords
